<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    import UPDATE from '@/components/page/update.vue'
    //接口地址url的统一管理
    import URL from '@/views/trade/util/url'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    import Qs from 'qs'
    let reportTypeList = {1:"额度调整-存取款",2:"额度调整-赠金送出"};
    let proposalStatusList = {0:"未审批",1:"已取消",2:"已审核"};
    export default {
        name: 'real',
        components: {
            tablePage,
            FORM,
            UPDATE
        },
        methods: {
            /*表格按钮点击事件*/
            bthClick (clickName, row) {
                if("approveProposal" == clickName){
                    this.dataChanage(URL.balance.realAdjustment.approveProposal,{id:row.id},res => {
                        if (res.code == 0){
                            this.$refs.childUpdate.close();
                            this.$message.success("suc");
                        }else{
                            this.$message.error(res.message);
                        }
                    })
                }else if("cancelProposal" == clickName){
                    this.dataChanage(URL.balance.realAdjustment.cancelProposal,{id:row.id},res => {
                        if (res.code == 0){
                            this.$refs.childUpdate.close();
                            this.$message.success("suc");
                        }else{
                            this.$message.error(res.message);
                        }
                    })
                }
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if("查询" == clickName){
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                }else if("添加" == clickName){
                    this.$refs.childUpdate.open();
                }
            },
            submit(model){
                this.dataChanage(URL.balance.realAdjustment.addProposal,model,res => {
                    if (res.code == 0){
                        this.$refs.childUpdate.close();
                        this.$message.success("suc");
                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
            dataChanage(url,option,suc,fail){
                this.$axios.post(url, Qs.stringify(option || {})).then(res => {
                    this.$refs.childTable.defaultGetData(this.queryData);
                    if(suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if(fail && (typeof fail == 'function')) fail(res);
                })
            }
        },
        data () {
            return {
                queryData:{},
                updateData:{
                    cols:[
                        { title: "交易账号", field: 'account',required:true},
                        { title: "调整类型", field: 'reportType',type:2,optionList:reportTypeList,required:true},
                        { title: "调整金额", field: 'transAmount',required:true},
                        { title: "备注", field: 'remark'},
                    ],
                },
                /*from查询表单*/
                formData:{
                  //hasLable: true,
                  cols:[
                      { title: "交易账号", field: 'account'},
                      { title: "提案号", field: 'proposalNo'},
                      { title: "调整类型", field: 'reportType',type:2,optionList:reportTypeList},
                      { title: "提案状态", field: 'proposalStatus',type:2,optionList:proposalStatusList},
                      {click:"查询"},
                      {click:"添加"},
                      ]
                },
                /*table生成*/
                pageData: {
                    isShow: false,
                    queryUrl: URL.balance.realAdjustment.query, //请求路径和参数
                    selection: false,
                    sequence: true,
                    cols: [
                        { title: "交易账号", field: 'account'},
                        { title: "平台", field: 'platform'},
                        { title: "提案号", field: 'proposalNo'},
                        { title: "调整类型", field: 'reportType',render:(data,full)=>{
                            return reportTypeList[data];
                        }},
                        { title: "账户币种", field: 'currency'},
                        { title: "调整金额", field: 'transAmount'},
                        { title: "提案人", field: 'proposer'},
                        { title: "审批人", field: 'approveUser'},
                        { title: "提案状态", field: 'proposalStatus',render:(data,full)=>{
                                return proposalStatusList[data];
                            }},
                        { title: "提案时间", field: 'proposalTime',render:(data,full)=>{
                                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                            }},
                        { title: "提案ip", field: 'proposalIp'},
                        { title: "审批时间", field: 'updateTime',render:(data,full)=>{
                                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                            }},
                        { title: "备注", field: 'remark'},
                        {title: "操作",width:250,btnClick:[
                                {name:"审批",click:"approveProposal",type:"primary",icon:"el-icon-edit",hidden:(data,full)=>{
                                        return full.proposalStatus != 0;
                                    }},
                                {name:"取消",click:"cancelProposal",type:"primary",icon:"el-icon-edit",hidden:(data,full)=>{
                                        return full.proposalStatus != 0;
                                    }},
                            ]}
                    ]
                }
            }
        }
    }
</script>
